import { render, staticRenderFns } from "./mainHot.vue?vue&type=template&id=12cb89fb&scoped=true&"
import script from "./mainHot.vue?vue&type=script&lang=js&"
export * from "./mainHot.vue?vue&type=script&lang=js&"
import style0 from "./mainHot.vue?vue&type=style&index=0&id=12cb89fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb89fb",
  null
  
)

export default component.exports